<template>
  <div 
  v-bind:class="{menuVisible: isMenuActive}" 
  class="site">

    <!-- Menu component -->
    <comp-menu></comp-menu><!-- Menu component -->
  
    <transition name="fade" mode="out-in" appear>
    <!-- Main page -->
    <router-view></router-view><!-- Main page -->
    </transition>

    <!-- Toaster component -->
    <comp-toaster></comp-toaster><!-- Toaster component -->

    <!-- Clickable layer to disable menu -->
    <div 
    v-on:click="closeMenu()"
    class="clickable-layer-to-close-menu"></div><!-- Clickable layer to disable menu -->

    <!-- Unclickable layer to disable menu -->
    <transition name="fade" appear>
    <div 
    v-if="!isOnline"
    class="unclickable-layer-to-close-menu">
      Check network connection
    </div><!-- Unclickable layer to disable menu -->
    </transition>

  </div>
</template>

<script>
import CompMenu from './CompMenu'
import CompToaster from './CompToaster'

export default {
  name: 'site',
  components: { CompMenu, CompToaster },
  created: function () {
    let siteId = this.$route.params.siteId
    console.log('siteId: ' + siteId)
  },
  computed: {
    isMenuActive: function () {
      return this.$store.getters.isMenuActive
    },
    isOnline: function () {
      return this.$store.getters.isOnline
    }
  },
  methods: {
    closeMenu: function () {
      this.$store.commit('CLOSE_MENU')
    }
  }
}
</script>

<style scoped>
  .site {
    font-size: 16px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    user-select: none;
    transform: translateX(0px);
    transition: transform .3s, .3s background .3s;
  }
  .site .clickable-layer-to-close-menu {
    padding: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: -1;
    display: none;
  }
  .site.menuVisible {
    transform: translateX(300px);
    background-color: hsl(210,30%,15%);
    transition: transform .3s, background 0s;
  }
  .site.menuVisible .clickable-layer-to-close-menu {
    z-index: 10000;
    display: block;
  }
  .site .unclickable-layer-to-close-menu {
    padding: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.9);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: rgba(255,255,255,0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
  }



  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .moveup-enter-active, .moveup-leave-active {
    transition: transform .5s;
  }
  .moveup-enter, .moveup-leave-to {
    transform: translateY(100%);
  }

</style>



// WEBPACK FOOTER //
// Site.vue?030a45aa